// Published backend contract verified. Single release rollback switch.
export const errorReportingFeatures = { enabled: true };
export const ERROR_LOG_VIEW = 'system.error_log.view';
export const ERROR_LOG_MANAGE = 'system.error_log.manage';
